var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { SliceEventList } from '../entities/slice-event-list';
import { classNames } from '../../utils/cn';
import { useUpcomingEvents } from '../../hooks/use-events';
import { ContentNode } from './content-node';
var cls = classNames('slice-layout-past-events');
export var SliceUpcomingEventsDefaultProps = {
  maxRowCount: 5,
  noEventsContent: 'There are no upcoming events currently scheduled. Please check back soon.'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1.35em;\n    line-height: 1.25em;\n    color: ", ";\n  "], ["\n    font-size: 1.35em;\n    line-height: 1.25em;\n    color: ", ";\n  "])), theme.COLOR('text'))
}); // -------- Components -------->

var My = {
  Container: styled(SliceEventList)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(ContentNode)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var SliceUpcomingEvents = function SliceUpcomingEvents(props) {
  var className = props.className,
      entity = props.entity;
  var events = useUpcomingEvents();

  if (!events.length) {
    return React.createElement(My.Content, {
      entity: {
        text: props.noEventsContent
      }
    });
  }

  return React.createElement(My.Container, {
    events: events,
    className: cls.name(className)
  });
};
SliceUpcomingEvents.defaultProps = SliceUpcomingEventsDefaultProps;
SliceUpcomingEvents.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;